module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigDiv"
  }, [_c('div', [_c('exclusive-progress', {
    attrs: {
      "progress": _vm.progress
    }
  })], 1), _vm._v(" "), (_vm.spuType === '1') ? _c('div', {
    staticClass: "titleDiv"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.downloadApp
    }
  }, [_c('span', [_vm._v("立即下载")])])]) : _vm._e(), _vm._v(" "), (_vm.spuType === '2') ? _c('div', {
    staticClass: "titleDiv1"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.downloadApp
    }
  }, [_c('span', [_vm._v("立即下载")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "topDiv"
  }, [(_vm.spuType === '1') ? _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/image/dream.png?x-oss-process=style/thumbnail_hd&time=1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.spuType === '2') ? _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/image/commemorate.png?x-oss-process=style/thumbnail_hd&time=1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "registerDiv",
    on: {
      "click": _vm.downloadApp
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.regT))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.regV))])]), _vm._v(" "), _c('div', {
    staticClass: "footerDiv"
  }, [_c('exclusive-dest')], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "bgDiv",
    attrs: {
      "id": "bgDiv"
    }
  }), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon003@2x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon003@2x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spuDiv"
  }, [_c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/1.jpg?t=2"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/2.jpg?t=2"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/3.jpg?t=2"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/4.jpg?t=2"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/5.jpg?t=2"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/6.jpg?t=2"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/7.jpg?t=2"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/8.jpg?t=2"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/9.jpg?t=2"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/10.jpg?t=2"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://cdn.matl.binstar.vip/spu/bec4150ddbb6458081dfba795abb1915/resources/11.jpg?t=2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottomDiv"
  }, [_c('span', [_vm._v("本次活动最终解释权归深圳市比邻心科技有限公司所有")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgImg",
    attrs: {
      "id": "bgImg"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/Group 540@2x.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b156db2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operation/Exclusive.vue
// module id = 467
// module chunks = 1